import React from 'react'
import Icon from '../Icon/Icon'

import {
  FooterNavigation,
  LogoSocial,
  NavigationColumn,
  NavigationContent,
  NavigationLabel,
  DescriptionItem,
  EmailLink,
  VeloeLogo,
  TelephoneNumber,
  Row
} from './styles'

export const Logo = 'height: 30px; width: 74px;'

function FooterNavigationLarge() {
  return (
    <FooterNavigation>
      <NavigationContent>
        {/* Coluna 1: Central de Relacionamento */}
        <NavigationColumn>
          <LogoSocial>
            <Icon
              icon="veloe-logo"
              svgStyle={VeloeLogo}
              width="74"
              height="31"
              viewBox="0 0 74 31"
            />
          </LogoSocial>
          <NavigationLabel>Central de relacionamento Pessoa Física</NavigationLabel>

          <Row>
            <NavigationLabel>WhatsApp</NavigationLabel>
            <TelephoneNumber>(11) 3003 3510</TelephoneNumber>
            <DescriptionItem>24 horas 7 dias por semana</DescriptionItem>
          </Row>

          <Row>
            <NavigationLabel>Telefone</NavigationLabel>
            <TelephoneNumber>3003 3510</TelephoneNumber>
            <DescriptionItem>Capitais e regiões metropolitanas</DescriptionItem>

            <TelephoneNumber>0800 208 3510</TelephoneNumber>
            <DescriptionItem>Demais cidades</DescriptionItem>
            <DescriptionItem>De segunda a sábado, das 08h às 20h</DescriptionItem>
          </Row>
        </NavigationColumn>

        {/* Coluna 2: SAC */}
        <NavigationColumn>
          <NavigationLabel bold>SAC</NavigationLabel>

          <Row>
            <NavigationLabel>WhatsApp</NavigationLabel>
            <TelephoneNumber>0800-208-2010</TelephoneNumber>
            <DescriptionItem>24 horas 7 dias por semana</DescriptionItem>
          </Row>

          <Row>
            <NavigationLabel>Telefone</NavigationLabel>
            <TelephoneNumber>0800-208-2010</TelephoneNumber>
            <DescriptionItem>De segunda a sábado, das 08h às 20h</DescriptionItem>
          </Row>

          {/* Nova seção para Deficiente Auditivo/Fala */}
          <Row>
            <NavigationLabel>Deficiente Auditivo/Fala</NavigationLabel>
            <TelephoneNumber>0800-208-2020</TelephoneNumber>
            <DescriptionItem>24 horas 7 dias por semana</DescriptionItem>
          </Row>
        </NavigationColumn>

        {/* Coluna 3: Ouvidoria */}
        <NavigationColumn>
          <NavigationLabel bold>Ouvidoria</NavigationLabel>

          <Row>
            <NavigationLabel>Telefone</NavigationLabel>
            <TelephoneNumber>0800 202 3278</TelephoneNumber>
            <DescriptionItem>De segunda a sexta, das 10h às 16h</DescriptionItem>
          </Row>

          <Row>
            <NavigationLabel>E-mail</NavigationLabel>
            <EmailLink>meajuda@veloe.com.br</EmailLink>
          </Row>
        </NavigationColumn>
      </NavigationContent>
    </FooterNavigation>
  )
}

export default FooterNavigationLarge
